import { type ReactNode } from 'react';
import * as React from 'react';
import styled, { useTheme } from 'styled-components';

export interface IconArgs {
  iconSize?: number;
  name: string;
  path: ReactNode;
  transform: string;
}

export interface IconProps {
  children?: never;
  className?: string;
  color?: string;
}

const Wrapper = styled.span<{ $color: string; $size: number }>`
  color: ${({ $color }) => $color};
  display: flex;
  height: ${({ $size }) => `${$size}px`};
  width: ${({ $size }) => `${$size}px`};
`;

export const createIcon = ({
  name,
  path,
  transform,
  iconSize
}: IconArgs): React.ComponentType<IconProps> =>
  React.memo(function Icon({ className, color }) {
    const theme = useTheme();
    const SIZE = iconSize || 15;

    return (
      <Wrapper
        $color={color || theme.iconColor.DEFAULT}
        $size={SIZE}
        className={className}>
        <svg
          data-icon={name}
          height={SIZE}
          viewBox={`0 0 ${SIZE} ${SIZE}`}
          width={SIZE}>
          <desc>{name}</desc>
          <g strokeWidth="1">
            <g transform={transform}>{path}</g>
          </g>
        </svg>
      </Wrapper>
    );
  });
